import type React from 'react';

import type { Table, RowData } from '@tanstack/react-table';
import { Checkbox } from '@vlabs/uikit/components/controls/checkbox/Checkbox';
import type { WithDataTestid } from '@vlabs/uikit/types';

import { buildTableViewCell } from './buildTableViewCell';
import { buildTestid } from '../../../lib/utils';

export interface SelectHeaderProps<TData extends RowData> extends WithDataTestid {
  table: Table<TData>;
}

const displayName = 'SelectHeader';
const testid = buildTestid(displayName);

function SelectHeader<TData extends RowData>({
  table,
  'data-testid': dataTestId = undefined,
}: SelectHeaderProps<TData>): React.JSX.Element {
  return buildTableViewCell({
    ...testid(dataTestId),
  })(
    <Checkbox
      checked={table.getIsAllRowsSelected() || table.getIsSomePageRowsSelected()}
      indeterminate={table.getIsSomePageRowsSelected()}
      onChange={table.getToggleAllRowsSelectedHandler()}
      {...testid('SelectAllRowsCheckbox', dataTestId)}
    />,
  );
}

export { SelectHeader };
